enum RequestStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  NOT_STARTED = 'NOT_STARTED',
}

export default RequestStatus
